module.exports = __webpack_public_path__ + "img/cc-technology.85f91a9b.svg";